import { supportedLocoLocalesSet } from '../supportedLocales'
import { languageCodesMapping } from '../translations.types'

const findLanguageMapping = (langCode: string) => {
  const mappingEntry = Object.entries(languageCodesMapping).find(entry => entry[0] === langCode)

  return mappingEntry?.[1] || undefined
}

export const checkLocaleAvailability = (
  locale: string,
  supportedAppLocalesSet: ReadonlySet<string>
): { supported: boolean; code: string } => {
  const isSupported = supportedLocoLocalesSet.has(locale) && supportedAppLocalesSet.has(locale)
  const mappedLocale = findLanguageMapping(locale)

  if (!isSupported && mappedLocale) {
    return {
      supported: supportedLocoLocalesSet.has(mappedLocale) && supportedAppLocalesSet.has(mappedLocale),
      code: mappedLocale
    }
  }

  return {
    supported: isSupported,
    code: mappedLocale || locale
  }
}
